import { render, staticRenderFns } from "./cooling.vue?vue&type=template&id=3830e2ae&"
import script from "./cooling.vue?vue&type=script&lang=js&"
export * from "./cooling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports